<div class="grid">
	<div [class]="col6ResponsiveButtonLayout('left')">
		<p-button id="exportDataDevice" label="{{ 'EXPORT_DATA_FROM_DEVICE' | translate }}" (click)="exportData()"
			icon="pi cm-cloud-arrow-up" [rounded]="false" [text]="true" severity="warning"
			styleClass="font-bold border-yellow-600">
		</p-button>
	</div>
	<div [class]="col6ResponsiveButtonLayout('right')">
		<p-button label="{{ 'IMPORT_DATAS_FROM_FILE' | translate }}" icon="pi cm-cloud-arrow-down" (click)="importFromFile()"
			[rounded]="false" [text]="true" severity="secondary" styleClass="font-bold border-0">
		</p-button>
	</div>
	<!-- ALERT SUCCESS, WARNING or ERROR IMPORT FILE -->
	<div class="col-12 pt-0">
		<div *ngIf="importFileSuccess === ImportFileSharingSuccess.NOT_IMPORTED_BLOCK_ERRORS" class="flex align-items-center justify-content-center bg-red-200 p-1 border-round-xl gap-1">
			<i class="pi cm-cancel text-xl text-red-700"></i>
			<p-tag value="{{'VCT_UPLOAD_WRITE_DATA_FAILED' | translate}}" severity="danger"></p-tag>
		</div>
		<div *ngIf="importFileSuccess === ImportFileSharingSuccess.IMPORTED_SUCCESS_WARNINGS_AND_ERRORS">
			<div class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl gap-1">
				<i class="pi cm-alert text-xl text-yellow-700"></i>
				<p-tag value="{{'VCT_UPLOAD_WRITE_DATA_DONE_WITH_ERRORS_AND_WARNINGS' | translate}}" severity="warning"></p-tag>
			</div>
			<div *ngIf="mtmaChanges" class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl gap-1">
				<i class="pi cm-cloud-arrow-down text-xl text-yellow-700"></i>
				<p-tag value="{{'NOTE_WRITE_DEVICE_AFTER_IMPORT_SUCCESS' | translate}}" severity="warning"></p-tag>
			</div>
		</div>
		<div *ngIf="importFileSuccess === ImportFileSharingSuccess.IMPORTED_SUCCESS_WARNINGS">
			<div class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl gap-1">
				<i class="pi cm-alert text-xl text-yellow-700"></i>
				<p-tag value="{{'VCT_UPLOAD_WRITE_DATA_DONE_WITH_WARNING' | translate}}" severity="warning"></p-tag>
			</div>
			<div *ngIf="mtmaChanges" class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl gap-1">
				<i class="pi cm-cloud-arrow-down text-xl text-yellow-700"></i>
				<p-tag value="{{'NOTE_WRITE_DEVICE_AFTER_IMPORT_SUCCESS' | translate}}" severity="warning"></p-tag>
			</div>
		</div>
		<div *ngIf="importFileSuccess === ImportFileSharingSuccess.IMPORTED_SUCCESS_ERRORS">
			<div class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl gap-1">
				<i class="pi cm-alert text-xl text-yellow-700"></i>
				<p-tag value="{{'VCT_UPLOAD_WRITE_DATA_DONE_WITH_ERRORS' | translate}}" severity="warning"></p-tag>
			</div>
			<div *ngIf="mtmaChanges" class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl gap-1">
				<i class="pi cm-cloud-arrow-down text-xl text-yellow-700"></i>
				<p-tag value="{{'NOTE_WRITE_DEVICE_AFTER_IMPORT_SUCCESS' | translate}}" severity="warning"></p-tag>
			</div>
		</div>
		<div *ngIf="importFileSuccess === ImportFileSharingSuccess.IMPORTED_SUCCESS">
			<div class="flex align-items-center justify-content-center bg-green-200 p-1 border-round-xl gap-1">
				<i class="pi cm-check text-xl text-green-700"></i>
				<p-tag value="{{'VCT_UPLOAD_WRITE_DATA_DONE' | translate}}" severity="success"></p-tag>
			</div>
			<div *ngIf="mtmaChanges" class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl gap-1">
				<i class="pi cm-cloud-arrow-down text-xl text-yellow-700"></i>
				<p-tag value="{{'NOTE_WRITE_DEVICE_AFTER_IMPORT_SUCCESS' | translate}}" severity="warning"></p-tag>
			</div>
		</div>
	</div>
</div>
<p-accordion>
	<p-accordionTab>
		<ng-template pTemplate="header">
			<div class="grid flex align-items-center w-full pt-2 -mb-2">
				<div [class]="!onExtendedMobile() ? 'col-12' : 'col-12 flex justify-content-center'" class="py-0">
					<span class="font-semibold white-space-nowrap">{{'IMPORT_DATA_INTO_DEVICE' | translate }}</span>
				</div>
			</div>
		</ng-template>
		<div>
			<app-mtma-import-export-list></app-mtma-import-export-list>
		</div>
	</p-accordionTab>
</p-accordion>
